import React from 'react'

/* based on / shamelessly copied from http://www.cssscript.com/pure-css-circular-percentage-bar/ */

type Props = {
  percentage: number, 
  text: ?string, 
  color: "green"|"orange"|"red", 
  size: ?("normal"|"big"|"small"|"xsmall")
}

const Circle = (props: Props = defaultProps) => {
  return (
    <div 
      className={`c100 p${props.percentage} ${props.color} ${(!props.size || props.size == "normal") ? "" : props.size}`}
    >
    <span>{props.text || `${props.percentage}%`}</span>
      <div className="slice">
        <div className="bar" />
        <div className="fill" />
      </div>
    </div>
  )
}

export default Circle
